import { render, staticRenderFns } from "./UserPreferencesElement.vue?vue&type=template&id=45c8f194&scoped=true&"
import script from "./UserPreferencesElement.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserPreferencesElement.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserPreferencesElement.vue?vue&type=style&index=0&id=45c8f194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8f194",
  null
  
)

export default component.exports